export default __webpack_public_path__ + "static/media/BOSCH_Logo.a7436e8a.svg";